import { Box, css, Stack, styled, Typography } from '@mui/material';

import { LEVEL_OF_SERVICE_COLORS } from '@/modules/LevelOfServiceColors';
import { useMapStore } from '@/stores/useMapStore';

const StyledStack = styled(Stack)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: row;
    background-color: ${theme.palette.common.white};
    padding: 0 ${theme.spacing(1.5)};
    border-radius: ${theme.spacing(0.5)};
    width: ${theme.spacing(45.25)};
  `,
);

const StyledGradientBox = styled(Box)(
  ({ theme }) => css`
    width: 100%;
    height: ${theme.spacing(1)};
    opacity: 0.75;
    background: linear-gradient(to right, ${LEVEL_OF_SERVICE_COLORS.map(({ color }) => color).join(', ')});
    border-radius: ${theme.spacing(0.5)};
  `,
);

export function LevelOfServiceLegend() {
  const { levelOfService } = useMapStore((state) => state.layersControl);

  return levelOfService ? (
    <StyledStack>
      <Typography mr={1}>langsam</Typography>
      <StyledGradientBox />
      <Typography ml={1}>schnell</Typography>
    </StyledStack>
  ) : null;
}
